<section class="sps-zuordnung">

  <header class="kopf">
    <button mat-icon-button type="button" (click)="zurSpsPruefung()" matTooltip="Zurück zur SPS-Prüfung">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <h2>SPS-Signalzuordnung</h2>
    <span class="kopf-hinweis">Konfliktklärung und Kontrolle – nicht Teil des normalen Prüfablaufs; gleiche Signale werden beim Import automatisch zusammengeführt.</span>
  </header>

  <!--
    Technische Grundlage. Liste der ungeklärten Zuordnungen (ungeklaerte) mit
    Kandidaten, Aktionen zuordnen() / eigenstaendig() / automatisch() und die
    Konfliktbehandlung (konflikt → Konfliktlösung wählen) folgen als Oberfläche.
  -->

  <p *ngIf="laedt || arbeitet">Wird geladen …</p>
  <p *ngIf="fehler" class="fehler">{{ fehler }}</p>

  <p *ngIf="!laedt">
    {{ ungeklaerte.length }} ungeklärte Zuordnung(en)
    <ng-container *ngIf="letztesAutomatikErgebnis">
      · automatisch geklärt: {{ letztesAutomatikErgebnis.verknuepft }} von {{ letztesAutomatikErgebnis.geprueft }}
    </ng-container>
  </p>

  <!-- BEREINIGUNG DOPPELTER SIGNALE -->
  <div class="bereinigung">
    <h3>Doppelte Signale bereinigen</h3>

    <p class="hinweis">
      Gleiche Signale werden bei jedem SPS-Import automatisch zusammengeführt – auch über Listentypen hinweg
      und für bereits vorhandene Duplikate. Dieser Bericht ist nur noch zur Kontrolle und für Daten gedacht,
      die vor dieser Automatik importiert wurden; er ist ein Dry-Run und ändert nichts. Angewendet werden nur
      sichere Zusammenführungen (gleiche Adresse, Richtung und Adressraum, kein widersprüchliches Prüfergebnis);
      Konflikte bleiben zur manuellen Entscheidung.
    </p>

    <div class="aktionen">
      <button mat-stroked-button type="button" (click)="berichtLaden()" [disabled]="arbeitet">
        Bericht erstellen (Dry-Run)
      </button>
      <button mat-flat-button color="primary" type="button" (click)="bereinigungAnwenden()"
              [disabled]="arbeitet || !bericht || (bericht.anzahlZusammenfuehrungen + bericht.anzahlVerwaisteSignale + bericht.anzahlKlaerungen + (bericht.anzahlNamensanpassungen || 0)) === 0">
        Sichere Bereinigung anwenden
      </button>
    </div>

    <p *ngIf="bereinigungErgebnis" class="ergebnis">
      Angewendet: {{ bereinigungErgebnis.zusammenfuehrungen }} Zusammenführung(en) ({{ bereinigungErgebnis.signaleAufgegangen }} Signale aufgegangen),
      {{ bereinigungErgebnis.verwaisteGeloescht }} verwaiste Signal(e) entfernt, {{ bereinigungErgebnis.klaerungen }} Zuordnung(en) bestätigt.
      Signale: {{ bereinigungErgebnis.signaleVorher }} → {{ bereinigungErgebnis.signaleNachher }}.
      Verbleibende Konflikte: {{ bereinigungErgebnis.verbleibendeKonflikte }}.
    </p>

    <ng-container *ngIf="bericht">
      <p>
        Signale: {{ bericht.signaleVorher }} → {{ bericht.signaleNachher }} ·
        sichere Zusammenführungen: {{ bericht.anzahlZusammenfuehrungen }} ({{ bericht.anzahlSignaleAufgehend }} Signale gehen auf) ·
        verwaiste Signale: {{ bericht.anzahlVerwaisteSignale }} ·
        Klärungen: {{ bericht.anzahlKlaerungen }} ·
        Konflikte: {{ bericht.anzahlKonflikte }} ·
        bewusst getrennt: {{ bericht.anzahlTrennungen }} ·
        Anzeigenamen: {{ bericht.anzahlNamensanpassungen || 0 }}
      </p>

      <details *ngIf="bericht.zusammenfuehrungen.length > 0">
        <summary>Sichere Zusammenführungen ({{ bericht.zusammenfuehrungen.length }})</summary>
        <ul>
          <li *ngFor="let z of bericht.zusammenfuehrungen">
            <strong>{{ z.adresseNormiert }}</strong> ({{ z.richtung }}): Ziel #{{ z.zielSignalId }} ← #{{ z.quellSignalIds.join(', #') }}
            <span *ngIf="z.ergebnisName"> · Name „{{ z.ergebnisName }}“</span>
            · Ergebnis {{ z.ergebnisPruefstatus }}
            <span *ngIf="z.unterschiede.length > 0"> · abweichende Angaben: {{ z.unterschiede.length }} Feld(er)</span>
            <div class="grund">{{ z.grund }}</div>
            <ul class="quellen">
              <li *ngFor="let s of z.signale">
                #{{ s.id }} „{{ s.name || '–' }}“ · {{ s.pruefstatus }}
                <ng-container *ngFor="let q of s.quellen">
                  <div class="grund">
                    {{ q.listeName }} Zeile {{ q.excelZeile }}: „{{ q.signalname || '–' }}“ {{ q.adresseOriginal }}
                    <span *ngIf="q.stationsName"> · Station {{ q.stationsName }}</span>
                    <span *ngIf="q.zuordnungsGrund"> · bisher: {{ q.zuordnungsGrund }}</span>
                  </div>
                </ng-container>
              </li>
            </ul>
          </li>
        </ul>
      </details>

      <details *ngIf="(bericht.namensanpassungen || []).length > 0">
        <summary>Anzeigenamen ({{ (bericht.namensanpassungen || []).length }}) – nur der Name ändert sich</summary>
        <ul>
          <li *ngFor="let n of bericht.namensanpassungen || []">
            #{{ n.signalId }} {{ n.adresseNormiert }}: „{{ n.bisherigerName || '–' }}“ → „{{ n.neuerName }}“
            <div class="grund">{{ n.grund }}</div>
          </li>
        </ul>
      </details>

      <details *ngIf="bericht.konflikte.length > 0" open>
        <summary>Manuell zu entscheiden ({{ bericht.konflikte.length }})</summary>
        <ul>
          <li *ngFor="let k of bericht.konflikte; trackBy: trackByKonflikt">
            <strong>{{ k.adresseNormiert || '–' }}</strong> ({{ k.richtung }}) · {{ k.art }} · Signale #{{ k.signalIds.join(', #') }}
            <div class="grund">{{ k.grund }}</div>
            <div class="grund">{{ k.hinweis }}</div>
            <div class="aktionen" *ngIf="k.signalIds.length > 1">
              <button mat-button type="button" (click)="konfliktZusammenfuehren(k, 'ZielBehalten')" [disabled]="arbeitet">
                Zusammenführen, Status von #{{ k.signalIds[0] }} behalten
              </button>
              <button mat-button type="button" (click)="konfliktZusammenfuehren(k, 'QuelleUebernehmen')" [disabled]="arbeitet">
                Zusammenführen, Status von #{{ k.signalIds[1] }} übernehmen
              </button>
              <button mat-button type="button" (click)="konfliktGetrenntLassen(k)" [disabled]="arbeitet">
                Getrennt lassen
              </button>
            </div>
          </li>
        </ul>
      </details>

      <details *ngIf="bericht.verwaisteSignale.length > 0">
        <summary>Verwaiste Signale ohne Quelle und ohne Prüfung ({{ bericht.verwaisteSignale.length }})</summary>
        <ul>
          <li *ngFor="let v of bericht.verwaisteSignale">#{{ v.id }} {{ v.adresseNormiert }} {{ v.name }}</li>
        </ul>
      </details>

      <p *ngFor="let h of bericht.hinweise" class="hinweis">{{ h }}</p>
    </ng-container>
  </div>

</section>
